import { SplitActionProps } from '.';

export const requiredProps: SplitActionProps = {};

const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as SplitActionProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
